module.exports = __webpack_public_path__ + "static/img/bg_old.676447d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_old.png
// module id = 66MH
// module chunks = 3